import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getThemeProp } from 'theme';

const disabledStyling = ({ isDisabled }) =>
  isDisabled &&
  `
    opacity: 0.5;
    pointer-events: none;
`;

const dangerStyling = ({ isDanger, theme }) =>
  isDanger &&
  `
    color: ${getThemeProp('colors.danger', theme)};
    &:hover {
      background-color: ${getThemeProp('colors.danger', theme)};
      color:${getThemeProp('colors.white', theme)};
    }
`;

const activeStyling = ({ isActive, theme }) =>
  isActive && `background-color: ${getThemeProp('colors.athensGrey2', theme)};`;

const Container = styled.div`
  align-items: center;
  color: #475369;
  display: flex;
  font-size: 12px;
  font-weight: 300;
  justify-content: space-between;
  line-height: 39px;
  padding: 0 1rem;

  &:hover {
    background-color: #e6e6ec;
    color: #475369;
    cursor: pointer;
  }

  ${dangerStyling};
  ${disabledStyling};
  ${activeStyling};
`;

const DropdownItem = ({
  children,
  className = '',
  isActive = false,
  isDanger = false,
  isDisabled = false,
  ...restProps
}) => (
  <Container
    className={className}
    isActive={isActive}
    isDanger={isDanger}
    isDisabled={isDisabled}
    {...restProps}
  >
    {children}
  </Container>
);

DropdownItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  isDanger: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default DropdownItem;
